export default __webpack_public_path__ + "static/Group-148808-eaa24aa03189d1f1be519d9d2b56a2c5.png";